module.exports = __webpack_public_path__ + "static/memorial_card_img2-c11d4e438227103f23a14ff9b767ff41.jpg";